import debounce from 'lodash-es/debounce';
import take from 'lodash-es/take';
import $ from 'jquery';

async function getFuse(list, options) {
  const { default: Fuse } = await import(
    /* webpackChunkName: "components/fuse" */
    'fuse.js'
  )

  return new Fuse(list, options);
}

var $input;
var $peopleContainer;
var $people;
var list;
var fuse;

export default async function init() {
    $input = $('.js-people-search__query');
    $peopleContainer = $('.js-people-search__people-container');
    $people = $('.js-short-profile').clone();

    if (!$people.length) {
      return;
    }
    list = short_profiles_dom_to_fuse_list($people);

    var fuseOptions = {
        shouldSort: true,
        threshold: 0.6,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        // minMatchCharLength: 3,
        keys: [
            {name: "name", weight: 0.5},
            {name: "refinement", weight: 0.2},
            {name: "title", weight: 0.2},
            {name: "organization", weight: 0.1},
        ],
    };

    fuse = await getFuse(list, fuseOptions);

    $input.on('keyup', debounce(search_people_with_fuse, 200));
}

function search_people_with_fuse() {
    $peopleContainer.html('');

    if($input.val() === "") {
        $people.appendTo($peopleContainer);
        return;
    }

    var results = take(fuse.search($input.val()), 15);

    $.each(results, function(i, r) {
        if(typeof $people[r.item.index] !== 'undefined') {
            $($people[r.item.index]).appendTo($peopleContainer);
        }
    });

    // ShortPixel is not replacing images after having searched for people.
    window.ShortPixelAI?.replacerService?.updateImages?.(window.ShortPixelAI);
    window.wpImageResizer?.observer?.observe?.();
}

function short_profiles_dom_to_fuse_list($people) {
    // The result is converted into an array, as Fuse expect `forEach` to be
    // present.
    return [...$people.map(function(index, person) {
        var titleInfo = $(person).data('title').split(',');
        return {
            'index': index,
            'id': $(person).data('id'),
            'name': $(person).data('name'),
            'title': titleInfo[0],
            'refinement': titleInfo[1],
            'organization': titleInfo[2],
        };
    })];
}
